import React from 'react';

function Navigation({ categories }) {
  const getSubCategoryUrl = (subcategory) => {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set('dbg_sc', subcategory.Id);
    return location.pathname + '?' + searchParams.toString();
  };

  const isActiveCategory = (subcategoryId) => {
    let searchParams = new URLSearchParams(window.location.search);
    const activeSubCategoryId = searchParams.get('dbg_sc')?.toLocaleLowerCase();
    return subcategoryId.toLocaleLowerCase() === activeSubCategoryId;
  };

  const getSubcategories = (category) => {
    return category.SubCategories.map((subcategory) => {
      return (
        <div className="mb-2" key={subcategory.Id}>
          <a className={isActiveCategory(subcategory.Id) ? 'fw-bold' : ''} href={getSubCategoryUrl(subcategory)}>
            {subcategory.Name}{' '}
          </a>
        </div>
      );
    });
  };
  const categoriesList = categories.map((category) => {
    return (
      <div className="pt-2" key={category.Id}>
        <div className="d-flex">
          <i className={category.Icon}></i>
          <div>
            <span className="dbg_navigation__header heading6 d-block mb-2">{category.Name}</span>
            {getSubcategories(category)}
          </div>
        </div>
      </div>
    );
  });
  return <div className="dbg_navigation">{categoriesList}</div>;
}
export default Navigation;
